import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as BackIcon } from 'assets/volver.svg';
import { RootState } from "redux/store";
import { removeLastStep,  } from "redux/features/stepperSlice";
import { useLocation } from "react-router-dom";

const BackButton: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentStep = useSelector((state: RootState) => state.stepper.currentStep);


  const handlePreviousStep = () => {
    dispatch(removeLastStep()); // Elimina el último paso de la lista

  };
  if (location.pathname !== "/" || currentStep <= 1) {
    return <></>;
  }
  return (
      <BackIcon
        onClick={handlePreviousStep}
        style={{
          width: "20px",
          height: "20px",
          marginRight: "10px",
          fill: "white",
        }}
      /> 
  );
};

export default BackButton;
